import React from "react";
import LabelWithInputDisabled from "../../../components/generic/LabelWithInputDisabled";
import MatchTypeComponent from "./MatchTypeComponent";
import MappingViewLink from "./MappingViewLink";
import "../../../styles/viewDetail.css";

function FileToDbView(props) {
  return (
    <div>
      <LabelWithInputDisabled label="Test Suite" value={props.testSuite} />
      <MatchTypeComponent
        matchType={props.matchType}
        fileName={props.fileName}
      />
      <LabelWithInputDisabled label="Delimiter" value={props.delimiter} />
      <div className="vd-row">
        <span className="vd-label">Mapping</span>
        <span className="vd-value">
          <MappingViewLink
            mappingName={props.mappingName}
            mappingDetail={props.mappingDetail}
          />
        </span>
      </div>
    </div>
  );
}

export default FileToDbView;
